import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useUnAssignDriver = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onUnAssignDriverError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while un-assigning driver.',
    );
  };

  const onUnAssignDriverSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Driver unassigned successfully.');
    modalContext?.setShowModal(false);
  };

  const unAssignDriver = async (data: any) => {
    const url: HttpConfig = {
      url: `api/v1/fleets/${data.id}/unassign`,
      method: 'post',
      data: data,
    };
    await request(url, onUnAssignDriverSuccess, setLoading, onUnAssignDriverError);
  };

  return { unAssignDriver, loading };
};

export default useUnAssignDriver;
